import React, { useRef, useState, useEffect } from 'react';
import FlipMove from 'react-flip-move';
import Link from 'next/link';
import LazyLoad from 'react-lazyload';
import { useOutsideClick } from '../../helpers'; // Will change this to @helpers once merged
import { ContentWrapper } from './PartnersStyles';

const PartnersPage = ({ contentHeader, partners }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState({
    id: 1,
    label: 'All Partners',
  });
  const [filteredPartners, setFilteredPartners] = useState(partners);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const ref = useRef();

  useOutsideClick(ref, () => {
    if (dropdownOpen) setDropdownOpen(false);
  });

  useEffect(() => {
    const options = [{ id: 1, label: 'All Partners' }];
    const map = new Map();

    for (const [index, partner] of partners.entries()) {
      if (!map.has(partner.category)) {
        map.set(partner.category, true);
        options.push({
          id: index + 2,
          label: partner.category,
        });
      }
    }

    setDropdownOptions(options);
  }, []);

  const handleFilter = (option) => {
    setDropdownOpen(false);
    setSelectedFilter(option);
    setFilteredPartners(() => {
      if (option.label === 'All Partners') return partners;
      return partners.filter((partner) => partner.category === option.label);
    });
  };

  const toggleDropdown = () => setDropdownOpen((dropdown) => !dropdown);

  return (
    <ContentWrapper>
      <div className="container">
        <div className="row filter-row">
          <h2>{contentHeader}</h2>
          <div className="dropdown" ref={ref}>
            <button
              className="btn btn-outline-secondary dropdown-toggle"
              type="button"
              id="partnerFilter"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => toggleDropdown()}
              onKeyDown={() => toggleDropdown()}
            >
              {selectedFilter.label}
            </button>
            <div
              className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}
              aria-labelledby="partnerFilter"
            >
              {dropdownOptions.map((option) => (
                <span
                  role="button"
                  key={option.id}
                  className="dropdown-item"
                  onClick={() => handleFilter(option)}
                  onKeyDown={() => handleFilter(option)}
                  tabIndex={0}
                >
                  {option.label}
                </span>
              ))}
            </div>
          </div>
        </div>
        <FlipMove className="partner-wrapper">
          {filteredPartners.map((partner, idx) =>
            // if partner wants user to be directed externally
            partner.external_url ? (
              <div className={`card-div ${partner.partner_name}`}>
                <a
                  href={partner.external_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={`${partner.slug}-${idx}`}
                >
                  <div className="card">
                    <LazyLoad offset={500}>
                      <img src={partner.logo} alt={partner.partner_name} width="200px" height="200px"/>
                    </LazyLoad>
                    <div className="copy">
                      <p className="name">{partner.partner_name}</p>
                      <p className="description">{partner.short_description}</p>
                    </div>
                    <div className="learn-more">
                      <span>Learn More {'>'}</span>
                    </div>
                  </div>
                </a>
              </div>
            ) : (
              <div className={`card-div ${partner.partner_name}`}>
                <Link
                  href="/partnerships/[slug]"
                  as={`/partnerships/${partner.slug}`}
                  key={`${partner.slug}-${idx}`}
                >
                  <a>
                    <div className="card">
                      <LazyLoad offset={500}>
                        <img src={partner.logo} alt={partner.partner_name} width="200px" height="200px"/>
                      </LazyLoad>
                      <div className="copy">
                        <p className="name">{partner.partner_name}</p>
                        <p className="description">
                          {partner.short_description}
                        </p>
                      </div>
                      <div className="learn-more">
                        <span>Learn More {'>'}</span>
                      </div>
                    </div>
                  </a>
                </Link>
              </div>
            )
          )}
        </FlipMove>
      </div>
    </ContentWrapper>
  );
};

export default PartnersPage;
